import React from "react";
import TextInput from "./TextInput";
import NumberFormat from "react-number-format";

const NumberInput = React.forwardRef((props, ref) => {
  const { fixedDecimalScale = true, ...filteredProps } = props;

  return (
    <NumberFormat
      {...filteredProps}
      getInputRef={ref}
      fixedDecimalScale={fixedDecimalScale}
      customInput={TextInput}
    />
  );
});
export default NumberInput;
